module.exports = __webpack_public_path__ + "static/media/OurStory-YellowBlock.7f2a233a.svg";